'use client'

import { useEffect, useRef } from "react"

export default function MapToggleButton({
    
}: {
    
}) {

    const ref = useRef<HTMLButtonElement>(null)
    const refInitialHeight = useRef(null)

    useEffect(() => {
        refInitialHeight.current = getComputedStyle(document.getElementById("map")).height
    }, [])

    return (
        <>
            <button
                id="toggle-carte" 
                ref={ref}
                className="button masquer bg-primary text-white"
                onClick={() => {
                    //if (document.getElementById("map").classList.contains("d-none")) {
                    if (getComputedStyle(document.getElementById("map")).height === refInitialHeight.current) {    
                        //document.getElementById("map").classList.remove("d-none")
                        document.getElementById('map').style.height = '0'
                        ref.current.querySelector('i').classList.remove('fi-rr-eye-crossed')
                        ref.current.querySelector('i').classList.add('fi-rr-eye')
                        ref.current.querySelector('span').textContent = 'Afficher la carte'
                    }
                    else {
                        //document.getElementById("map").classList.add("d-none")
                        document.getElementById('map').style.height = refInitialHeight.current
                        ref.current.querySelector('i').classList.remove('fi-rr-eye')
                        ref.current.querySelector('i').classList.add('fi-rr-eye-crossed')
                        ref.current.querySelector('span').textContent = 'Masquer la carte'
                    }
                }}
            >
                <i className="fi fi-rr-eye-crossed" />
                <span>Masquer la carte</span>
            </button>
        </>
    )
}